import styled from '@happymoneyinc/styled-components';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTimelineContext } from './TimelineContext.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const TimelinePoint = _ref => {
  let {
    children,
    className,
    color,
    icon,
    ...rest
  } = _ref;
  const {
    horizontal
  } = useTimelineContext();
  return /*#__PURE__*/jsxs(StyledContainer, {
    color: color,
    className: clsx({
      horizontal
    }, className),
    ...rest,
    children: [children, icon ? /*#__PURE__*/jsx("span", {
      className: "timeline-wrapper-icon",
      children: icon
    }) : /*#__PURE__*/jsx("div", {
      className: clsx({
        'timeline-point-vertical': !horizontal
      }, 'timeline-point')
    }), /*#__PURE__*/jsx("div", {
      className: "timeline-line"
    })]
  });
};
const StyledContainer = styled.div`
  .timeline-line {
    position: absolute;
    top: 24px;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 1px;
    height: calc(100% - 24px);
    content: '';
    border: 1px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.gray[3];
}};
  }

  &.horizontal {
    align-items: center;
    display: flex;

    .timeline-line {
      position: absolute;
      top: 0;
      left: 12px;
      z-index: -1;
      width: calc(100% - 24px);
      height: 1px;
      content: '';
      border: 1px solid ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.gray[3];
}};
    }
  }

  .timeline-wrapper-icon {
    position: absolute;
    left: -0.75rem;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 24px;
    height: 24px;
  }

  .timeline-point {
    position: absolute;
    left: -0.375rem;
    width: 0.75rem;
    height: 0.75rem;
    background-color: ${_ref4 => {
  let {
    theme,
    color
  } = _ref4;
  return color || theme.colors.gray[3];
}};
    border-color: #E2E2E2;
    border-width: 2px;
    border-radius: 9999px;
  }

  .timeline-point-vertical {
    margin-top: 0.375rem;
  }
`;
TimelinePoint.defaultProps = {
  className: '',
  children: null,
  color: null,
  icon: null
};
TimelinePoint.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { TimelinePoint };
//# sourceMappingURL=TimelinePoint.js.map
